import { ApiInvoice, ApiXeroTokenData } from "./interface.api";
import { useCallback, useState } from "react";

import { ApiHooksProps } from "../interface";
import { Invoice } from "@/types";
import { invoicesApiMapper } from './mappers';
import { request } from "../request";

const hook = ({ setError, setLoading, setSuccess, serverPath, token }: ApiHooksProps) => {

  const appName = "photoplanet",
        xeroFirstLoginKey = "xero-first-login";

  const currentUrl = `${window.location.protocol}//${window.location.host}`;

  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [invoiceCount, setInvoiceCount] = useState(0);

  const countOwnUnpaidInvoices = useCallback(async () => {
    const path = `${serverPath}/invoices/count/`;
    request(path, { method: 'GET', token });
  }, [serverPath, token]);

  const generateInvoiceByOrderIds = useCallback(async (orderIds: string[]) => {
    const path = `${serverPath}/invoices/generate/`;

    setLoading(true);
    try {
      await request(path, { body: orderIds, token });
      setSuccess('Invoices generated!');
    } catch (error: unknown) {
      if (typeof error === 'string') {
        setError(error);
      }
      else if (error instanceof Error) {
        setError(error.message || '');
      }
    }
    setLoading(false);

    return;
  }, [serverPath, token, invoices]);

  const listOwnInvoices = useCallback(async (userId: string | null) => {
    const path = `${serverPath}/invoices/list/${userId}`;

    setLoading(true);
    try {
      const res = await request<never, ApiInvoice[]>(path, { method: 'GET', token });
      setInvoices(invoicesApiMapper(res))
      //setSuccess('Invoices generated!')
    } catch (error: unknown) {
      if (typeof error === 'string') {
        setError(error);
      }
      else if (error instanceof Error) {
        setError(error.message || '');
      }
    }
    setLoading(false);

    return;
  }, [serverPath, token]);

  const getInvoiceCount = useCallback(async () => {
    const path = `${serverPath}/invoices/count/`;
    const res = await request<never, number>(path, { method: 'GET', token });
    setInvoiceCount(res);
  }, [serverPath, token]);

  const setPaidManual = useCallback(async (invoiceIds: string[]) => {
    const path = `${serverPath}/invoices/setPaidManual/`;

    setLoading(true);
    try {
      await request(path, { body: invoiceIds, token });
      setInvoices(invoices.map((invoice) => ({
        ...invoice,
        paid: true,
      })))
      setSuccess('Invoices set to paid!')
    } catch (error: unknown) {
      if (typeof error === 'string') {
        setError(error);
      }
      else if (error instanceof Error) {
        setError(error.message || '');
      }
    }
    setLoading(false);
  }, [serverPath, token, invoices]);

  const getAuthStatus = useCallback(async () => {
    const path = `${serverPath}/xero-oauth/status/`;
    const res = await request<never, boolean>(path, { method: 'GET', token });

    return res;
  }, [serverPath, token]);

  const getAuthUrl = useCallback(async () => {

    const path = `${serverPath}/xero-oauth/auth-url?callbackUri=${encodeURIComponent(currentUrl)}&state=${appName}`;
    const res = await request<never, string>(path, { method: 'GET', token });

    return res;
  }, [serverPath, token]);

  const connectXero = useCallback(async (code:string) => {
    const path = `${serverPath}/xero-oauth/connect/`;
    const body : ApiXeroTokenData = {
      CallbackUri: currentUrl,
      Code: code
    } 

    await request<ApiXeroTokenData, string>(path, { body, token });
    localStorage.setItem(xeroFirstLoginKey, Date.now().toString());
  }, [serverPath, token]);

  const loginIfNeeded = async () =>{
    const loggedIn = await getAuthStatus();

    if (loggedIn) {
      console.log('Already logged in');
    } else {
      const lastLogin = (Number(localStorage.getItem(xeroFirstLoginKey)) || 0) <= Date.now() - 3e4;
      
      if (lastLogin) {
        const url = await getAuthUrl();
        window.location.replace(url);
    }
  }
}

  // const trySendAuthCodeToServer = async(errorFn:string) => {
  //   const url = window.location.href;
    
  //   const codeMatch = /code=(.+?)(&|$|#)/gi.exec(url);
  //   const code = codeMatch && codeMatch[1] || "";
    
  //   const stateMatch = /state=(.+?)(&|$|#)/gi.exec(url);
  //   const state = stateMatch && stateMatch[1] || "";

  //   const arg = code && state === appName ? code : "";

  //   if (arg) {
  //     await connectXero(arg);
  //     redirectToOriginalPage();
  //   } else {
  //     console.log(errorFn);
  //   }
  // }

  return {
    connectXero,
    countOwnUnpaidInvoices,
    generateInvoiceByOrderIds,
    getAuthStatus,
    getAuthUrl,
    getInvoiceCount,
    invoiceCount,
    invoices,
    listOwnInvoices,
    loginIfNeeded,
    setPaidManual
  }
}

export default hook;